import Scrollbars from 'react-custom-scrollbars-2';

import { MEDIA_DATA } from './constants/media-data.constant';

import MediaContact from './components/mediaContact/MediaContact';
import MediaSection from './components/mediaSection/MediaSection';
import Page from 'components/page/Page';
import PageWrapper from 'components/pageWrapper/PageWrapper';
import VideoBanner from 'components/videoBanner/VideoBanner';

import BannerMp4 from 'assets/contact/banner.mp4';
import BannerWebm from 'assets/contact/banner.webm';

import styles from './MediaRoute.module.scss';

const MediaRoute = () => {
  const { articles, movies, tvInterviews } = MEDIA_DATA;

  return (
    <Page pageBackground="dark">
      <Scrollbars style={{ width: '100%', height: '100%' }}>
        <PageWrapper landingFooter homeFooter={false}>
          <div className={styles['banner']}>
            <VideoBanner
              className={styles['banner-video']}
              webMVideoUrl={BannerWebm}
              mp4VideoUrl={BannerMp4}
              videoAnimationThreshold={0}
            />
            <div className="tw-z-4 tw-relative tw-flex tw-flex-col tw-py-[116px] tw-text-center sm:tw-py-[189px] sm:tw-pb-[199px]">
              <h1 className="tw-m-0 tw-text-center tw-text-[52px] tw-uppercase tw-text-white md:tw-text-[68px] xl:tw-text-8xl">
                Media
              </h1>
            </div>
          </div>
          <div className="tw-mx-auto tw-block tw-max-w-[1526px] tw-pb-[50px] sm:tw-pb-20">
            <MediaSection isVideo title="TV interviews" data={tvInterviews} />
            <MediaSection isVideo title="Influencer videos" data={movies} />
            <MediaSection title="Articles" data={articles} />
          </div>
          <MediaContact />
        </PageWrapper>
      </Scrollbars>
    </Page>
  );
};

export default MediaRoute;
